// 电力容量管理
export default [{
    path: 'ecm',
    component: () => import('@/views/dcim/ecm/ecm-index'),
    children: [{
        path: 'alert-record',
        component: () => import('@/views/dcim/ecm/alert-record-index')
    }, {
        path: 'ec-equipment',
        component: () => import('@/views/dcim/ecm/ec-equipment-index')
    }]
}]
